<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 70,
      height: 70,
      color: 'currentColor',
      viewBoxValue: `0 0 70 70`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <rect
      width="70"
      height="70"
      rx="35"
      fill="#D9D9D9"
    />
    <path
      d="M35 42C31.15 42 27.8542 40.6292 25.1125 37.8875C22.3708 35.1458 21 31.85 21 28C21 24.15 22.3708 20.8542 25.1125 18.1125C27.8542 15.3708 31.15 14 35 14C38.85 14 42.1458 15.3708 44.8875 18.1125C47.6292 20.8542 49 24.15 49 28C49 31.85 47.6292 35.1458 44.8875 37.8875C42.1458 40.6292 38.85 42 35 42ZM7 70V60.2C7 58.2167 7.511 56.3932 8.533 54.7295C9.555 53.0658 10.9107 51.7977 12.6 50.925C16.2167 49.1167 19.8917 47.7598 23.625 46.8545C27.3583 45.9492 31.15 45.4977 35 45.5C38.85 45.5 42.6417 45.9527 46.375 46.858C50.1083 47.7633 53.7833 49.119 57.4 50.925C59.0917 51.8 60.4485 53.0693 61.4705 54.733C62.4925 56.3967 63.0023 58.219 63 60.2V70H7Z"
      fill="#F3F3F3"
    />
  </IconBase>
</template>

<style scoped lang="scss"></style>
